import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

// Hardcoded local fallbacks (accurate translation maps)
export const fallbackResources = {
  en: {
    Login: {
      header: {
        appName: 'POD System',
        appSubtitle: 'Proof of Delivery',
      },
      form: {
        welcomeBack: 'Welcome back',
        welcomeSubtitle: 'Sign in to POD with your LEAP IAM email and password',
        emailLabel: 'Email address',
        emailPlaceholder: 'you@company.com',
        passwordLabel: 'Password',
        passwordPlaceholder: '••••••••',
        rememberMe: 'Remember me',
        forgotPasswordLink: 'Forgot password?',
        loginButton: 'Sign in securely',
        signingIn: 'Signing in…',
        requiredFieldError: 'Please input your Field!',
      },
      otp: {
        title: 'Two-Step Verification',
        description: 'We sent a 6-digit code to',
        backToLogin: 'Back to login',
        verifyButton: 'Sign in',
        verifying: 'Signing in…',
        successMessage: "We've sent a 6-digit code to your registered email.",
        otpBypassWarning: 'OTP from IAM (otp_bypass) was filled automatically. Remove otp_bypass from IAM responses in production.',
        devOtpFilled: 'Dev: OTP from login response is pre-filled. Disable with',
      },
      errors: {
        invalidCredentials: 'Invalid Credentials!',
        invalidEmailPassword: 'Invalid email or password.',
        networkError: 'Login failed due to network error.',
        emailValidation: 'Please enter a valid email address',
        passwordResetFailed: 'Failed to send reset link.',
      },
      brand: {
        title: 'Ship with confidence.',
        subtitle: 'confidence.',
        features: [
          {
            title: 'Proof of delivery, end to end',
            desc: 'Upload and track POD documents with SAP-aligned flows (ALT, DHR, GRN, and more).',
          },
          {
            title: 'Approvals that scale',
            desc: 'Requesters, approvers, and transporters each see the right queue and status.',
          },
          {
            title: 'IAM-secured access',
            desc: 'Same LEAP identity and MFA you use across the suite — sign in once, trust everywhere.',
          },
        ],
      },
      footer: {
        brandName: 'LEAP · POD System',
        agreement: 'By signing in you agree to our',
        termsOfService: 'Terms of Service',
        and: 'and',
        privacyPolicy: 'Privacy Policy',
        copyright: '© {{year}} LEAP India — Proof of Delivery (POD)',
      },
    },
    Sidebar: {
      menu: {
        dashboard: 'Dashboard',
        uploadPOD: 'Upload POD',
        bulkPodUpload: 'Bulk POD (drive)',
        approvalsSync: 'Sync approvals',
        pendingPOD: 'Pending POD',
        pendingPODReports: 'Pending POD Reports',
        PODReports: 'Reports',
        documentJourney: 'Document Journey',
        pendingUploadTransporter: 'Pending POD for Upload',
        pendingApproveTransporter: 'Pending approval',
        approvedTransporter: 'Transporter reports',
      },
      group: {
        overview: 'Overview',
      },
    },
    Header: {
      general: {
        appName: 'LEAP · POD',
        appSubtitle: 'Proof of Delivery',
        documentJourney: 'Document Journey',
        logout: 'Logout',
      },
    },
    UploadPOD: {
      header: {
        title: 'UPLOAD POD',
        description: 'Select type + document no, fetch from SAP, attach files, upload.',
      },
      fetch: {
        title: 'Fetch from SAP',
        subtitle: 'Only document type + number are required',
      },
      form: {
        transferTypePlaceholder: 'Transfer Type',
        documentNumberPlaceholder: 'Document Number',
        fetchDocumentButton: 'Fetch Document',
        docType: 'Document Type',
        docTypeRequired: 'Please select document type',
        docTypePlaceholder: 'Select document type',
        docNo: 'Document Number',
        docNoRequired: 'Please enter document number',
        docNoPlaceholder: 'Enter document number',
        fetching: 'Fetching…',
        fetch: 'Fetch',
      },
      details: {
        title: 'Fetched Details',
        subtitle: 'Read-only (from SAP)',
        empty: 'Fetch a document to see details.',
        existingAttachment: 'Existing attachment found in system (latest status: {{status}}). You can still upload a new attachment.',
        fields: {
          DocumentNo: 'Document Number',
          DocNo: 'Document Number',
          DocType: 'Document Type',
          Type: 'Type',
          Year: 'Year',
          PostingDate: 'Posting Date',
          FromLocation: 'From Location',
          ToLocation: 'To Location',
          Quantity: 'Quantity',
          VehicleNo: 'Vehicle Number',
          LRNo: 'LR Number',
          LR_No: 'LR Number',
          CustomerCode: 'Customer Code',
          CustomerName: 'Customer Name',
          Transporter: 'Transporter Code',
          TransporterCode: 'Transporter Code',
          TransporterName: 'Transporter Name',
          MaterialCodeNo: 'Material Code Number',
          MaterialDocNo: 'Material Document Number',
          ActualQty: 'Actual Quantity',
          ExcessQty: 'Excess Quantity',
          ShortQty: 'Short Quantity',
          dms_document: 'DMS Document',
          has_document: 'Has Document',
        },
      },
      types: {
        ALT: 'Allot(ALT)',
        DHR: 'Dehire(DHR)',
        GRN: 'Goods Receipt Note(GRN)',
        REL_OUT: 'Relocation(RELO)',
        TS: 'Trading Sale(TS)',
        ZLSC: 'Trading Sale(TS)',
        job_work: 'job_work',
        trading_cell: 'trading_cell',
      },
      upload: {
        title: 'Attachments',
        description: 'Upload JPG/PNG/PDF. Multiple files will be merged into one PDF. Max 25MB.',
        clickDrag: 'Click or drag files to upload',
        acceptedFormats: 'Accepted: {{types}}. Max merged size: 25MB.',
        remove: 'Remove',
        uploading: 'Uploading…',
        submit: 'Upload',
      },
      errors: {
        fetchErrorTitle: 'Fetch Error',
        fetchErrorDesc: 'Failed to fetch document. Please try again.',
        unsupportedFileTitle: 'Unsupported File',
        unsupportedFileDesc: 'File "{{fileName}}" is not supported.',
        noFilesTitle: 'No Files',
        noFilesDesc: 'Please upload at least one file.',
        noDocumentTitle: 'No Document',
        noDocumentDesc: 'Please fetch a document first.',
        fileSizeTitle: 'File Size Error',
        fileSizeDesc: 'Attachments cannot exceed 25 MB.',
        mergeErrorTitle: 'Merge Error',
        mergeErrorDesc: 'Failed to merge files. Please try again.',
        noDocTitle: 'No Document',
        noDocContent: 'Please fetch a document from SAP first.',
        noFilesContent: 'Please upload at least one file.',
        fileSizeContent: 'Attachments cannot exceed 25 MB.',
      },
      messages: {
        uploadSuccess: 'Document uploaded successfully!',
        uploadFailed: 'Upload failed',
        fetchSuccess: 'Document details fetched from SAP',
        fetchFailed: 'Failed to fetch document from SAP',
        validationError: 'Please enter document number and select document type',
        noDetails: 'SAP did not return document details.',
      },
      status: {
        columnTitle: 'POD Status',
        toUpload: 'To upload',
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
      },
    },
    BulkPodUpload: {
      header: {
        headerTitle: 'Bulk Upload POD',
        description: 'Upload many POD files at once. Supported formats: PDF, PNG, JPG. Filenames must match SAP document numbers.',
      },
      tabs: {
        local: 'Local folder',
        cloud: 'Google Drive / SharePoint',
      },
      requirements: {
        title: 'Before you upload',
        body: 'Each filename (without extension) must be a valid SAP document number. PDF is preferred when multiple formats exist for the same document.',
      },
      sections: {
        configTitle: 'Configuration',
        configSubtitle: 'Document type applies to every file in this batch',
        filesTitle: 'Select files',
        filesSubtitle: 'Filenames must match SAP document numbers (before the extension)',
        runTitle: 'Run upload',
        runSubtitle: 'Each document uploads to storage, then SAP and approvals run before the next',
        cloudTitle: 'Cloud folder import',
      },
      picker: {
        folderTitle: 'Select folder',
        folderHint: 'Import all supported files from a folder recursively',
        filesTitle: 'Select files',
        filesHint: 'Pick specific PDF, PNG, or JPG files',
        selectedCount: '{{count}} files ready to upload',
        empty: 'No files selected yet',
      },
      progress: {
        uploading: 'Uploading files to storage…',
        storing: 'Saving file list to server…',
        processing: 'Processing queue on server…',
        pipeline: 'Uploading & processing documents one at a time…',
        complete: 'Processing complete',
        elapsed: 'Elapsed',
        currentDocument: 'Current document',
        runStats: '{{ok}} succeeded · {{fail}} failed',
      },
      resume: {
        done: 'Already processed',
        remaining: 'To upload',
        retry: 'Retry',
        new: 'New',
        hint: 'Re-running upload will skip processed files and continue with the rest.',
      },
      cooldown: {
        title: 'Rate limit cooldown',
        description: 'Pausing to respect API limits. Processing resumes automatically.',
      },
      source: {
        sourceTitle: 'Drive source',
        sourceSubtitle: 'Serial import (thousands of files) runs on the server in order',
      },
      instructions: {
        googleLabel: 'Google:',
        googlePart1: 'use a',
        googlePart2: 'link and share that folder with the Drive service-account identity from',
        sharepointLabel: 'SharePoint:',
        sharepointPart1: 'use an org share link — the API needs',
        sharepointPart2: 'application credentials against Microsoft Graph (see',
      },
      form: {
        folderUrl: 'Folder / share URL',
        folderUrlPlaceholder: 'https://drive.google.com/drive/folders/… or https://…sharepoint.com/…',
        folderUrlRequired: 'Paste Drive or SharePoint folder link',
        docType: 'Document type (SAP)',
        docTypePlaceholder: 'Select document type',
        delay: 'Delay between files (ms)',
        start: 'Start bulk import',
        starting: 'Starting…',
        refresh: 'Refresh status',
        upload: 'Start upload',
        pipeline: 'Uploading & processing…',
        resumeUpload: 'Resume upload ({{count}} left)',
        stop: 'Stop upload',
        uploading: 'Uploading…',
        storing: 'Saving…',
        processing: 'Processing…',
        ingestingFiles: 'Uploading files…',
      },
      job: {
        jobTitle: 'Job #{{id}}',
        jobSubtitle: 'Live counters from the backend',
        jobStatus: 'Status',
        provider: 'Provider',
        totalQueued: 'Total queued',
        processed: 'Processed',
        succeeded: 'Succeeded',
        failed: 'Failed',
      },
      table: {
        tableTitle: 'Files',
        tableSubtitle: 'Per-file SAP fetch + S3 + DB outcomes',
      },
      columns: {
        file: 'File',
        docNo: 'Doc №',
        source: 'Source',
        columnStatus: 'Status',
        approvalId: 'Approval ID',
        error: 'Error',
        outcome: 'Outcome',
        updatedAt: 'Updated',
      },
      summary: {
        summaryTitle: 'Batch results',
        summarySubtitle: 'Counts below match the file table — click a category to filter rows',
        elapsed: 'Total time',
        processed: 'Total Processed',
        updated: 'Approved from Pending (Case 1)',
        inserted: 'Approved Inserted (Case 3)',
        skipped: 'Skipped Approved (Case 2)',
        attachments: 'Attachments Stored',
        failed: 'Failed (Errors)',
      },
      stats: {
        totalFiles: 'Files in batch',
        attachments: 'Extra attachments',
        failedTotal: 'Failed (all errors)',
        filterHint: 'Click a category to filter the file table below',
        showingFiltered: 'Showing {{shown}} of {{total}} files in batch',
        tableScope: '{{total}} files in this batch',
        loadingBatch: 'Loading batch statistics…',
      },
      history: {
        title: 'All-time bulk upload history',
        subtitle: 'Lifetime counts across local folder uploads and cloud Drive/SharePoint imports',
        subtitleWithDate: 'Lifetime counts across local folder and cloud imports · Last activity {{date}}',
        totalFiles: 'Total files (all time)',
        successful: 'Successful',
        failed: 'Failed',
        inProgress: 'In progress',
        totalRuns: 'Upload runs',
        localBatches: 'Local batches',
        cloudJobs: 'Cloud jobs',
        uniqueDocuments: 'Unique documents (local)',
        firstActivity: 'First upload',
        recentLocal: 'Recent local batches',
        recentCloud: 'Recent cloud import jobs',
        batchId: 'Batch',
        files: 'Files',
        outcomes: 'Outcomes',
        lastActivity: 'Last activity',
        progress: 'Progress',
        created: 'Created',
        jobId: 'Job',
        loadError: 'Could not load upload history',
      },
      analysis: {
        total: 'Total',
      },
      outcomes: {
        allFiles: 'All files in batch',
        inserted_new: 'New approval inserted',
        inserted_from_pending: 'Approved from pending',
        skipped_already_approved: 'Skipped (already approved)',
        failed_s3: 'S3 upload failed',
        failed_sap: 'SAP / document error',
        failed_retry_exhausted: 'Failed (max retries)',
        failed_rate_limit: 'Rate limited (429)',
        rolled_back: 'Rolled back',
        processing: 'Processing',
        pending: 'Pending',
      },
      filters: {
        status: 'Filter by status',
        outcome: 'Filter by outcome',
        search: 'Search doc № or filename',
      },
      export: {
        button: 'Download Excel',
        success: 'Export downloaded',
        failed: 'Export failed',
      },
      retry: {
        rateLimited: 'Retry rate-limited ({{count}})',
      },
      rollback: {
        button: 'Revert upload',
        badge: 'Rolled back',
        title: 'Revert this upload',
        description: 'This will permanently delete database records and S3 files created by this upload. Pre-existing approvals are not modified except for attachments added in this batch.',
        approvals: 'Approvals to delete',
        attachments: 'Attachments to delete',
        s3: 'S3 objects to delete',
        queueRows: 'Queue rows affected',
        checkbox: 'I understand this cannot be undone and want to revert this upload',
        confirmAction: 'Revert this upload',
        reverting: 'Reverting…',
        success: 'Upload reverted successfully',
      },
      messages: {
        startSuccess: 'Bulk POD job started — processing folder in the background',
        startFailed: 'Failed to start job',
        foundFiles: 'Found {{count}} supported files to process.',
        processComplete: 'Bulk upload processing completed',
        polling: 'Processing POD queue on the server…',
        reconnecting: 'Reconnecting to active upload job…',
        cooldownToast: 'Cooldown active — {{processed}} done, {{pending}} remaining',
        processingToast: '{{processed}} done, {{pending}} remaining',
        emptyFolder: 'Folder is empty or permission was denied',
        unsupportedFiles: 'No supported files found. Extensions seen: {{ext}}',
        alreadyQueued: 'Files already in queue — starting processing',
        skippedExisting: '{{count}} files already queued — uploading the rest',
        uploadFailed: 'Upload failed',
        jobAlreadyRunning: 'Another batch is still processing on the server',
        emptyBatch: 'No files were registered for this batch — try uploading again or contact support',
        processTimeout: 'Processing is taking longer than expected — refresh to check status',
        retryRateLimited: 'Re-queued {{count}} rate-limited files for processing',
        checkingProcessed: 'Checking which files are already processed…',
        processedCheckReady: '{{done}} already processed · {{remaining}} to upload',
        processedCheckFailed: 'Could not check processed files',
        uploadCancelled: 'Upload stopped — re-select the same folder to continue',
        interruptedTitle: 'Previous upload was interrupted',
        interruptedBody: 'Batch {{batchId}} had {{done}} of {{total}} documents processed. Click Resume to continue.',
        resuming: '{{done}} already complete — continuing {{remaining}} documents',
        partialComplete: 'Finished with {{failed}} document errors — re-run the same folder to retry',
        allAlreadyDone: 'All files in this folder were already processed',
      },
    },
    ApprovalsSync: {
      header: {
        title: 'Sync approvals',
        description: 'Copy legacy approval rows from an auth database into POD until database cutover.',
      },
      sections: {
        sourceTitle: 'Source auth database',
        sourceSubtitle:
          'Databases on this MySQL server whose name contains "auth". Sync reads from approvals in the selected database.',
        previewTitle: 'Sync preview',
        previewSubtitle: 'Compare row counts between the selected source and POD before running a sync.',
      },
      source: {
        label: 'Selected source',
        placeholder: 'Select auth database',
        hint: 'Databases are discovered from the connected MySQL server (name contains "auth").',
        empty: 'No auth databases found on this server',
        noTable: 'no approvals table',
        rows: 'rows',
        unknownRows: 'unknown rows',
      },
      table: {
        database: 'Database',
        approvalsTable: 'approvals table',
        rowCount: 'Rows',
        present: 'Present',
        missing: 'Missing',
        selected: 'Selected',
        use: 'Use',
      },
      kpi: {
        environment: 'Environment',
        podDb: 'POD database',
        sourceDb: 'Source database',
        sourceRows: 'Source rows',
        podRows: 'POD rows',
        missing: 'Not found',
        delta: 'Difference',
        inSync: 'Counts match',
        sourceAhead: 'Source has more rows',
        podAhead: 'POD has more rows',
        ready: 'Ready to sync',
        validSource: 'Valid source',
        invalidSource: 'Select a valid source',
      },
      actions: {
        refresh: 'Refresh preview',
      },
      merge: {
        title: 'Merge from source',
        description:
          'Upsert rows by id. Existing POD approvals are updated; new ids are inserted. Safe for repeated syncs.',
        note: 'Recommended while you are still cutting over from legacy auth databases.',
        action: 'Merge from source',
        running: 'Merging…',
        success: 'Approvals merged from source',
      },
      replace: {
        action: 'Replace from source',
        title: 'Replace POD approvals',
        panelDescription:
          'Truncates POD approvals and related bulk-upload tables, backs up current data, then copies all rows from the source.',
        note: 'Use only when you need a full reset of POD approval data from the selected source.',
        description:
          'This truncates POD approvals, approval attachments, and bulk-upload queue/mutation tables, then copies all rows from the selected auth database. A backup table is created first.',
        checkbox:
          'I understand this will wipe POD approval data and re-copy from the selected auth database',
        confirmAction: 'Replace approvals',
        running: 'Replacing…',
        success: 'Approvals replaced from source',
      },
      lastRun: {
        title: 'Last sync completed',
        source: 'Source',
        mode: 'Mode',
        affected: 'Rows affected',
        inserted: 'Rows inserted',
        backup: 'Backup table',
        completed: 'Completed',
      },
      errors: {
        previewFailed: 'Could not load sync preview',
        syncFailed: 'Sync failed',
      },
      progress: {
        title: 'Sync in progress',
        subtitle: 'Large databases are copied in batches. You can keep this page open until completion.',
        rows: '{{processed}} of {{total}} rows processed',
      },
    },
    PendingPOD: {
      header: {
        title: 'POD Pending Reports',
        description: 'Review and approve or reject pending POD documents',
      },
      actions: {
        bulkUpdate: 'Bulk Update ({{count}})',
        actionView: 'View',
        actionApprove: 'Approve',
        actionReject: 'Reject',
        approveAll: 'Approve All',
        rejectAll: 'Reject All',
        updateAll: 'Update All',
      },
      table: {
        tableTitle: 'Documents',
        tableSubtitle: 'Pending review — click any row for details',
      },
      modal: {
        reviewTitle: 'Review Document',
        approveTitle: 'Approve Document',
        rejectTitle: 'Reject Document',
        bulkTitle: 'Bulk Update ({{count}} documents)',
        viewTitle: 'View document',
        noAttachment: 'No attachment to preview.',
      },
      form: {
        actionLabel: 'Action',
        actionRequired: 'Please select an action',
        actionPlaceholder: 'Select action',
        reasonLabel: 'Reason',
        reasonRequired: 'Please select a reason',
        reasonPlaceholder: 'Select a reason',
        remarksLabel: 'Remarks',
        remarksRequired: 'Please provide remarks',
        remarksPlaceholder: 'Enter approval or rejection remarks...',
        bulkRemarksPlaceholder: 'Enter remarks for all selected documents...',
        actualQty: 'Actual Quantity Received',
        actualQtyPlaceholder: 'Actual Quantity',
        excessShortQty: 'Excess/Short Quantity',
        short_qty: 'Short',
      },
      messages: {
        updateSuccess: 'Approval updated successfully',
        updateFailed: 'Failed to update approval',
        bulkSuccess: 'Bulk update completed successfully',
        bulkFailed: 'Failed to bulk update approvals',
        selectAtLeastOne: 'Please select at least one approval',
        noAttachmentAvailable: 'No attachment available',
        approveSuccess: 'Approved successfully',
        rejectSuccess: 'Rejected successfully',
      },
      preview: {
        documentSummary: 'Document summary',
        sapAtFetch: 'SAP (at fetch)',
      },
    },
    DocumentJourney: {
      header: {
        title: 'Document Journey',
        transporterDesc: 'Documents uploaded under transporter code {{code}}. Open a row to see attachment history and status.',
        standardDesc: 'One document number can have multiple attachments with different statuses. Open a row for per-attachment status and actions.',
        detailDesc: 'Document {{docNo}} • {{count}} attachment(s). Status is shown per attachment below — one document can have several statuses.',
      },
      actions: {
        refresh: 'Refresh',
        back: 'Back',
        approve: 'Approve',
        reject: 'Reject',
      },
      table: {
        cardTitle: 'Documents',
        cardTransporterDesc: 'Your transporter documents only',
        cardStandardDesc: 'Grouped by document number',
        attachmentsTooltip: '{{count}} attachment(s)',
      },
      columns: {
        att: 'Att',
        documentNo: 'Document No',
        columnType: 'Type',
        columnCustomer: 'Customer',
        custCode: 'Cust. code',
        material: 'Material',
        year: 'Year',
        app: 'App',
        posting: 'Posting',
        columnFrom: 'From',
        columnTo: 'To',
        qty: 'Qty',
        actual: 'Actual',
        vehicle: 'Vehicle',
        lr: 'LR',
        tpt: 'Tpt',
        transporter: 'Transporter',
        lastUpdate: 'Last Update',
      },
      details: {
        cardSummaryTitle: 'Summary',
        cardSummaryDesc: 'Current snapshot',
        types: 'Types',
        detailCustomer: 'Customer',
        detailFrom: 'From',
        detailTo: 'To',
        sapSnapshot: 'SAP (latest attachment snapshot)',
        cardHistoryTitle: 'History',
        cardHistoryDesc: 'All status changes and attachments',
      },
      status: {
        Approved: 'Approved',
        Rejected: 'Rejected',
        Pending: 'Pending',
      },
      modal: {
        approveTitle: 'Approve attachment',
        rejectTitle: 'Reject attachment',
      },
      form: {
        docNo: 'Document No:',
        formType: 'Type:',
        formCustomer: 'Customer:',
        quantity: 'Quantity:',
        remarksLabel: 'Remarks',
        remarksRequired: 'Please provide remarks',
        remarksPlaceholder: 'Enter approval or rejection remarks...',
        btnCancel: 'Cancel',
        btnSubmit: 'Submit',
      },
      messages: {
        updateSuccess: 'Approval updated successfully',
        updateFailed: 'Failed to update approval',
      },
    },
    ReportsPOD: {
      header: {
        title: 'POD Reports',
        description: 'Filtered report and analytics for POD documents (same layout as the dashboard).',
      },
      actions: {
        excelReport: 'Export report',
        view: 'View',
      },
      kpi: {
        kpiTotal: 'Total',
        kpiMatchingFilters: 'Matching filters',
        kpiTotalDesc: 'Show all statuses — click to reset status filter',
        kpiPending: 'Pending',
        kpiInReview: 'In review',
        kpiApproved: 'Approved',
        kpiCompleted: 'Completed',
        kpiRejected: 'Rejected',
        kpiNeedsAction: 'Needs action',
      },
      filters: {
        filterTitle: 'Filters',
        filterDesc: 'Refine the table and summary statistics',
        filterDocType: 'Document Type',
        filterAllTypes: 'All types',
        filterStatus: 'Status',
        filterAllStatuses: 'All statuses',
        filterDateRange: 'Date Range',
        filterApply: 'Apply filters',
      },
      breakdown: {
        breakdownTitle: 'Document Types',
        breakdownDesc: 'Breakdown for current filters',
        breakdownNoData: 'No type breakdown yet.',
      },
      table: {
        tableTitle: 'Documents',
        tableDesc: 'Filtered results — click any row for document history',
      },
      modals: {
        detailsTitle: 'POD Details',
        viewTitle: 'View document',
      },
      columns: {
        id: 'ID',
        documentNo: 'Document No',
        docType: 'Doc Type',
        quantity: 'Quantity',
        postingDate: 'Posting Date',
        fromLocation: 'From Location',
        toLocation: 'To Location',
        transporterCode: 'Transporter Code',
        transporterName: 'Transporter Name',
        status: 'Status',
        action: 'Action',
        actions: 'Actions',
        year: 'Year',
        app: 'App',
        material: 'Material',
        customerCode: 'Cust. Code',
        customerName: 'Customer',
      },
      details: {
        status: 'Status',
        documentNo: 'Document No',
        postingDate: 'Posting Date',
        type: 'Type',
        materialCodeNo: 'Material Code No',
        fromLocation: 'From Location',
        toLocation: 'To Location',
        quantity: 'Quantity',
        vehicleNo: 'Vehicle No',
        user: 'User',
        attachment: 'Attachment',
        viewAttachment: 'View Attachment',
        downloadPdf: 'Download PDF',
        openInNewTab: 'Open in New Tab',
        loadingAttachment: 'Loading Attachment...',
        failedToLoad: 'Failed to load attachment.',
        noAttachment: 'No attachment to preview.',
      },
      types: {
        allot: 'Allot',
        grn: 'GRN',
        returnRequest: 'Return Request',
        relocation: 'Relocation',
        typeAllotment: 'Allot(ALT)',
        typeDhr: 'Dehire(DHR)',
        typeGrn: 'Goods Receipt Note(GRN)',
        typeRelOut: 'Relocation(RELO)',
        typeTradingSale: 'Trading Sale(TS)',
        typeJobWork: 'job_work',
        typeTradingCell: 'trading_cell',
      },
      status: {
        Approved: 'Approved',
        Rejected: 'Rejected',
        Pending: 'Pending',
      },
    },
    Common: {
      general: {
        loading: 'Loading...',
        save: 'Save',
        cancel: 'Cancel',
        reset: 'Reset',
        paginationTotal: 'Showing {{rangeStart}}–{{rangeEnd}} of {{total}} records',
        submit: 'Submit',
        close: 'Close',
        back: 'Back',
        next: 'Next',
        welcomeUser: 'Welcome back',
        kpiRollingDesc: 'KPIs below use the rolling window you select; POD Reports stays all-time unless you filter dates there.',
        rollingWindow: 'Rolling window',
        refreshingWindow: 'Refreshing window',
        last7days: 'Last 7 days',
        last15days: 'Last 15 days',
        last30days: 'Last 30 days',
        last60days: 'Last 60 days',
        last90days: 'Last 90 days',
        total: 'Total',
        inWindow: 'In window',
        inReview: 'In review',
        ofTotal: 'of total',
        completed: 'Completed',
        needsAction: 'Needs action',
        recentApprovals: 'Recent Approvals',
        quickLinks: 'Quick links',
        jumpToCommon: 'Jump to common workflows',
        transporterWorkflows: 'Transporter workflows',
        documentTypes: 'Document Types',
        breakdownWindow: 'Breakdown for the selected rolling window',
        open: 'Open',
      },
      errors: {
        required: 'This field is required',
        invalidEmail: 'Please enter a valid email',
        somethingWrong: 'Something went wrong',
      },
    },
  },
  ar: {
    Login: {
      header: {
        appName: 'نظام إثبات التسليم (POD)',
        appSubtitle: 'إثبات التسليم',
      },
      form: {
        welcomeBack: 'مرحباً بك مجدداً',
        welcomeSubtitle: 'قم بتسجيل الدخول إلى إثبات التسليم باستخدام بريدك الإلكتروني وكلمة المرور',
        emailLabel: 'عنوان البريد الإلكتروني',
        emailPlaceholder: 'you@company.com',
        passwordLabel: 'كلمة المرور',
        passwordPlaceholder: '••••••••',
        rememberMe: 'تذكرني',
        forgotPasswordLink: 'هل نسيت كلمة المرور؟',
        loginButton: 'تسجيل الدخول بشكل آمن',
        signingIn: 'جاري تسجيل الدخول…',
        requiredFieldError: 'الرجاء إدخال الحقل!',
      },
      otp: {
        title: 'التحقق بخطوتين',
        description: 'أرسلنا رمزًا مكونًا من 6 أرقام إلى',
        backToLogin: 'العودة إلى تسجيل الدخول',
        verifyButton: 'تسجيل الدخول',
        verifying: 'جاري تسجيل الدخول…',
        successMessage: 'لقد أرسلنا رمز تحقق مكونًا من 6 أرقام إلى بريدك الإلكتروني المسجل.',
        otpBypassWarning: 'تم ملء رمز التحقق (OTP) من نظام إدارة الهوية والوصول (IAM) تلقائيًا. يرجى إزالة otp_bypass من استجابات IAM في بيئة الإنتاج.',
        devOtpFilled: 'بيئة التطوير: تم ملء رمز التحقق (OTP) مسبقًا من استجابة تسجيل الدخول. يمكنك تعطيل هذا باستخدام',
      },
      errors: {
        invalidCredentials: 'بيانات اعتماد غير صالحة!',
        invalidEmailPassword: 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
        networkError: 'فشل تسجيل الدخول بسبب خطأ في الشبكة.',
        emailValidation: 'الرجاء إدخال عنوان بريد إلكتروني صالح',
        passwordResetFailed: 'فشل إرسال رابط إعادة التعيين.',
      },
      brand: {
        title: 'اشحن بثقة.',
        subtitle: 'بثقة.',
        features: [
          {
            title: 'إثبات التسليم، من البداية للنهاية',
            desc: 'قم بتحميل وتتبع مستندات إثبات التسليم (POD) من خلال تدفقات متوافقة مع نظام SAP (مثل ALT وDHR وGRN وغيرها).',
          },
          {
            title: 'موافقات تتوسع بمرونة',
            desc: 'يرى كل من مقدمي الطلبات والمسؤولين عن الموافقة والناقلين قائمة الانتظار والحالة المناسبة لهم.',
          },
          {
            title: 'وصول آمن عبر نظام IAM',
            desc: 'نفس هوية LEAP والمصادقة متعددة العوامل (MFA) التي تستخدمها عبر المجموعة — سجل الدخول مرة واحدة، وثق في كل مكان.',
          },
        ],
      },
      footer: {
        brandName: 'نظام LEAP · إثبات التسليم (POD)',
        agreement: 'بتسجيل الدخول، فإنك توافق على',
        termsOfService: 'شروط الخدمة',
        and: 'و',
        privacyPolicy: 'سياسة الخصوصية',
        copyright: '© {{year}} LEAP India — نظام إثبات التسليم (POD)',
      },
    },
    Sidebar: {
      menu: {
        dashboard: 'لوحة القيادة',
        uploadPOD: 'تحميل إثبات التسليم (POD)',
        bulkPodUpload: 'تحميل جماعي (درايف)',
        approvalsSync: 'مزامنة الموافقات',
        pendingPOD: 'إثبات التسليم (POD) المعلق',
        pendingPODReports: 'تقارير إثبات التسليم (POD) المعلقة',
        PODReports: 'التقارير',
        documentJourney: 'رحلة المستند',
        pendingUploadTransporter: 'إثبات التسليم المعلق للرفع',
        pendingApproveTransporter: 'قيد الانتظار للموافقة',
        approvedTransporter: 'تقارير الناقل',
      },
      group: {
        overview: 'نظرة عامة',
      },
    },
    Header: {
      general: {
        appName: 'LEAP · POD',
        appSubtitle: 'إثبات التسليم',
        documentJourney: 'رحلة المستند',
        logout: 'تسجيل الخروج',
      },
    },
    UploadPOD: {
      header: {
        title: 'تحميل إثبات التسليم (POD)',
        description: 'حدد النوع ورقم المستند، واجلبه من SAP، وأرفق الملفات، ثم قم بالتحميل.',
      },
      fetch: {
        title: 'جلب من SAP',
        subtitle: 'مطلوب نوع المستند ورقم المستند فقط',
      },
      form: {
        transferTypePlaceholder: 'نوع التحويل',
        documentNumberPlaceholder: 'رقم المستند',
        fetchDocumentButton: 'جلب المستند',
        docType: 'نوع المستند',
        docTypeRequired: 'الرجاء تحديد نوع المستند',
        docTypePlaceholder: 'اختر نوع المستند',
        docNo: 'رقم المستند',
        docNoRequired: 'الرجاء إدخال رقم المستند',
        docNoPlaceholder: 'أدخل رقم المستند',
        fetching: 'جاري الجلب…',
        fetch: 'جلب',
      },
      details: {
        title: 'التفاصيل المجلوبة',
        subtitle: 'قراءة فقط (من SAP)',
        empty: 'اجلب مستنداً لعرض التفاصيل.',
        existingAttachment: 'تم العثور على مرفق موجود في النظام (آخر حالة: {{status}}). لا يزال بإمكانك تحميل مرفق جديد.',
        fields: {
          DocumentNo: 'رقم المستند',
          DocNo: 'رقم المستند',
          DocType: 'نوع المستند',
          Type: 'النوع',
          Year: 'السنة',
          PostingDate: 'تاريخ النشر',
          FromLocation: 'من الموقع',
          ToLocation: 'إلى الموقع',
          Quantity: 'الكمية',
          VehicleNo: 'رقم المركبة',
          LRNo: 'رقم LR',
          LR_No: 'رقم LR',
          CustomerCode: 'رمز العميل',
          CustomerName: 'اسم العميل',
          Transporter: 'رمز الناقل',
          TransporterCode: 'رمز الناقل',
          TransporterName: 'اسم الناقل',
          MaterialCodeNo: 'رقم رمز المادة',
          MaterialDocNo: 'رقم مستند المادة',
          ActualQty: 'الكمية الفعلية',
          ExcessQty: 'الكمية الزائدة',
          ShortQty: 'الكمية الناقصة',
          dms_document: 'مستند DMS',
          has_document: 'يحتوي على مستند',
        },
      },
      types: {
        ALT: 'تخصيص (ALT)',
        DHR: 'إلغاء التأجير (DHR)',
        GRN: 'إشعار استلام البضائع (GRN)',
        REL_OUT: 'تغيير الموقع (RELO)',
        TS: 'بيع تجاري (TS)',
        ZLSC: 'بيع تجاري (TS)',
        job_work: 'job_work',
        trading_cell: 'trading_cell',
      },
      upload: {
        title: 'تحميل المستندات',
        description: 'تحميل ملفات JPG/PNG/PDF. سيتم دمج ملفات متعددة في ملف PDF واحد. الحد الأقصى 25 ميغابايت.',
        clickDrag: 'انقر أو اسحب الملفات هنا لتحميلها',
        acceptedFormats: 'المقبول: {{types}}. الحد الأقصى للحجم المدمج: 25 ميغابايت.',
        remove: 'إزالة',
        uploading: 'جاري التحميل…',
        submit: 'تحميل',
      },
      errors: {
        fetchErrorTitle: 'خطأ في الجلب',
        fetchErrorDesc: 'فشل جلب المستند. يرجى المحاولة مرة أخرى.',
        unsupportedFileTitle: 'ملف غير مدعوم',
        unsupportedFileDesc: 'الملف "{{fileName}}" غير مدعوم.',
        noFilesTitle: 'لا توجد ملفات',
        noFilesDesc: 'يرجى تحميل ملف واحد على الأقل.',
        noDocumentTitle: 'لا يوجد مستند',
        noDocumentDesc: 'يرجى جلب مستند أولاً.',
        fileSizeTitle: 'خطأ في حجم الملف',
        fileSizeDesc: 'لا يمكن أن تتجاوز المرفقات 25 ميغابايت.',
        mergeErrorTitle: 'خطأ في الدمج',
        mergeErrorDesc: 'فشل دمج الملفات. يرجى المحاولة مرة أخرى.',
        noDocTitle: 'لا يوجد مستند',
        noDocContent: 'الرجاء جلب مستند من SAP أولاً.',
        noFilesContent: 'الرجاء تحميل ملف واحد على الأقل.',
        fileSizeContent: 'لا يمكن أن تتجاوز المرفقات 25 ميغابايت.',
      },
      messages: {
        uploadSuccess: 'تم تحميل المستند بنجاح!',
        uploadFailed: 'فشل التحميل',
        fetchSuccess: 'تم جلب تفاصيل المستند من SAP بنجاح',
        fetchFailed: 'فشل في جلب المستند من SAP',
        validationError: 'الرجاء إدخال رقم المستند وتحديد نوع المستند',
        noDetails: 'لم يقم نظام SAP بإرجاع تفاصيل المستند.',
      },
      status: {
        columnTitle: 'حالة إثبات التسليم',
        toUpload: 'بانتظار التحميل',
        pending: 'قيد الانتظار',
        approved: 'تمت الموافقة',
        rejected: 'مرفوض',
      },
    },
    BulkPodUpload: {
      header: {
        headerTitle: 'تحميل جماعي لإثبات التسليم (POD)',
        description: 'انسخ رابط مجلد Google Drive عام أو رابط مشاركة SharePoint / OneDrive. يجب أن تكون الملفات المدعومة بصيغة PDF أو PNG أو JPG ويجب أن تطابق أسماء الملفات أرقام مستندات SAP قبل الامتداد.',
      },
      source: {
        sourceTitle: 'مصدر الدرايف (Drive)',
        sourceSubtitle: 'الاستيراد المتسلسل (الآلاف من الملفات) يعمل على الخادم بالترتيب',
      },
      instructions: {
        googleLabel: 'جوجل (Google):',
        googlePart1: 'استخدم رابط',
        googlePart2: 'وقم بمشاركة هذا المجلد مع هوية حساب خدمة Drive من',
        sharepointLabel: 'شيربوينت (SharePoint):',
        sharepointPart1: 'استخدم رابط مشاركة المؤسسة — تحتاج الواجهة البرمجية (API) إلى بيانات اعتماد تطبيق',
        sharepointPart2: 'مقابل Microsoft Graph (انظر',
      },
      form: {
        folderUrl: 'رابط المجلد / المشاركة',
        folderUrlPlaceholder: 'https://drive.google.com/drive/folders/… أو https://…sharepoint.com/…',
        folderUrlRequired: 'يرجى لصق رابط مجلد Drive أو SharePoint',
        docType: 'نوع المستند (SAP)',
        docTypePlaceholder: 'اختر نوع المستند',
        delay: 'تأخير بين الملفات (ملي ثانية)',
        start: 'بدء الاستيراد الجماعي',
        starting: 'جاري البدء…',
        refresh: 'تحديث الحالة',
      },
      job: {
        jobTitle: 'العملية رقم #{{id}}',
        jobSubtitle: 'عدادات مباشرة من الخادم الخلفي',
        jobStatus: 'الحالة',
        provider: 'المزود',
        totalQueued: 'إجمالي المنتظر',
        processed: 'تمت معالجته',
        succeeded: 'نجح',
        failed: 'فشل',
      },
      table: {
        tableTitle: 'الملفات',
        tableSubtitle: 'نتائج جلب SAP + S3 + قاعدة البيانات لكل ملف',
      },
      columns: {
        file: 'الملف',
        docNo: 'رقم المستند',
        source: 'المصدر',
        columnStatus: 'الحالة',
        approvalId: 'معرف الموافقة',
        error: 'الخطأ',
        outcome: 'النتيجة',
        updatedAt: 'آخر تحديث',
      },
      summary: {
        summaryTitle: 'الملخص',
        processed: 'إجمالي المعالج',
        inserted: 'تم الإدراج (حالة 3)',
        updated: 'من معلق إلى معتمد (حالة 1)',
        skipped: 'تم التخطي (حالة 2)',
        attachments: 'مرفقات محفوظة',
        failed: 'فشل (أخطاء)',
      },
      analysis: {
        total: 'الإجمالي',
      },
      outcomes: {
        inserted_new: 'موافقة جديدة',
        inserted_from_pending: 'معتمد من معلق',
        skipped_already_approved: 'تخطي (معتمد مسبقاً)',
        failed_s3: 'فشل رفع S3',
        failed_sap: 'خطأ SAP / المستند',
        failed_retry_exhausted: 'فشل (محاولات استنفدت)',
        rolled_back: 'تم التراجع',
        processing: 'قيد المعالجة',
        pending: 'منتظر',
      },
      filters: {
        status: 'تصفية حسب الحالة',
        outcome: 'تصفية حسب النتيجة',
        search: 'بحث برقم المستند أو اسم الملف',
      },
      export: {
        button: 'تنزيل Excel',
        success: 'تم تنزيل التصدير',
        failed: 'فشل التصدير',
      },
      rollback: {
        button: 'التراجع عن الرفع',
        badge: 'تم التراجع',
        title: 'التراجع عن هذا الرفع',
        description: 'سيحذف هذا سجلات قاعدة البيانات وملفات S3 التي أُنشئت في هذا الرفع بشكل دائم.',
        approvals: 'موافقات للحذف',
        attachments: 'مرفقات للحذف',
        s3: 'كائنات S3 للحذف',
        queueRows: 'صفوف قائمة الانتظار المتأثرة',
        checkbox: 'أفهم أن هذا لا يمكن التراجع عنه وأريد التراجع عن الرفع',
        confirmAction: 'التراجع عن الرفع',
        reverting: 'جاري التراجع…',
        success: 'تم التراجع عن الرفع بنجاح',
      },
      messages: {
        startSuccess: 'بدأت عملية الاستيراد الجماعي — جاري معالجة المجلد في الخلفية',
        startFailed: 'فشل بدء العملية',
        foundFiles: 'تم العثور على {{count}} ملفات مدعومة للمعالجة.',
        processComplete: 'اكتملت معالجة الرفع الجماعي',
      },
    },
    ApprovalsSync: {
      header: {
        title: 'Sync approvals',
        description: 'Copy legacy approval rows from an auth database into POD until database cutover.',
      },
      sections: {
        sourceTitle: 'Source auth database',
        sourceSubtitle:
          'Databases on this MySQL server whose name contains "auth". Sync reads from approvals in the selected database.',
        previewTitle: 'Sync preview',
        previewSubtitle: 'Compare row counts between the selected source and POD before running a sync.',
      },
      source: {
        label: 'Selected source',
        placeholder: 'Select auth database',
        hint: 'Databases are discovered from the connected MySQL server (name contains "auth").',
        empty: 'No auth databases found on this server',
        noTable: 'no approvals table',
        rows: 'rows',
        unknownRows: 'unknown rows',
      },
      table: {
        database: 'Database',
        approvalsTable: 'approvals table',
        rowCount: 'Rows',
        present: 'Present',
        missing: 'Missing',
        selected: 'Selected',
        use: 'Use',
      },
      kpi: {
        environment: 'Environment',
        podDb: 'POD database',
        sourceDb: 'Source database',
        sourceRows: 'Source rows',
        podRows: 'POD rows',
        missing: 'Not found',
        delta: 'Difference',
        inSync: 'Counts match',
        sourceAhead: 'Source has more rows',
        podAhead: 'POD has more rows',
        ready: 'Ready to sync',
        validSource: 'Valid source',
        invalidSource: 'Select a valid source',
      },
      actions: {
        refresh: 'Refresh preview',
      },
      merge: {
        title: 'Merge from source',
        description:
          'Upsert rows by id. Existing POD approvals are updated; new ids are inserted. Safe for repeated syncs.',
        note: 'Recommended while you are still cutting over from legacy auth databases.',
        action: 'Merge from source',
        running: 'Merging…',
        success: 'Approvals merged from source',
      },
      replace: {
        action: 'Replace from source',
        title: 'Replace POD approvals',
        panelDescription:
          'Truncates POD approvals and related bulk-upload tables, backs up current data, then copies all rows from the source.',
        note: 'Use only when you need a full reset of POD approval data from the selected source.',
        description:
          'This truncates POD approvals, approval attachments, and bulk-upload queue/mutation tables, then copies all rows from the selected auth database. A backup table is created first.',
        checkbox:
          'I understand this will wipe POD approval data and re-copy from the selected auth database',
        confirmAction: 'Replace approvals',
        running: 'Replacing…',
        success: 'Approvals replaced from source',
      },
      lastRun: {
        title: 'Last sync completed',
        source: 'Source',
        mode: 'Mode',
        affected: 'Rows affected',
        inserted: 'Rows inserted',
        backup: 'Backup table',
        completed: 'Completed',
      },
      errors: {
        previewFailed: 'Could not load sync preview',
        syncFailed: 'Sync failed',
      },
      progress: {
        title: 'Sync in progress',
        subtitle: 'Large databases are copied in batches. You can keep this page open until completion.',
        rows: '{{processed}} of {{total}} rows processed',
      },
    },
    PendingPOD: {
      header: {
        title: 'تقارير إثبات التسليم (POD) المعلقة',
        description: 'مراجعة واعتماد أو رفض مستندات إثبات التسليم المعلقة',
      },
      actions: {
        bulkUpdate: 'تحديث جماعي ({{count}})',
        actionView: 'عرض',
        actionApprove: 'موافقة',
        actionReject: 'رفض',
        approveAll: 'موافقة على الكل',
        rejectAll: 'رفض الكل',
        updateAll: 'تحديث الكل',
      },
      table: {
        tableTitle: 'المستندات',
        tableSubtitle: 'قيد المراجعة — اضغط على أي صف للتفاصيل',
      },
      modal: {
        reviewTitle: 'مراجعة المستند',
        approveTitle: 'اعتماد المستند',
        rejectTitle: 'رفض المستند',
        bulkTitle: 'تحديث جماعي ({{count}} مستندات)',
        viewTitle: 'عرض المستند',
        noAttachment: 'لا يوجد مرفق للمعاينة.',
      },
      form: {
        actionLabel: 'الإجراء',
        actionRequired: 'يرجى تحديد الإجراء',
        actionPlaceholder: 'حدد الإجراء',
        reasonLabel: 'السبب',
        reasonRequired: 'يرجى تحديد السبب',
        reasonPlaceholder: 'حدد السبب',
        remarksLabel: 'ملاحظات',
        remarksRequired: 'يرجى تقديم ملاحظات',
        remarksPlaceholder: 'أدخل ملاحظات الموافقة أو الرفض...',
        bulkRemarksPlaceholder: 'أدخل ملاحظات لجميع المستندات المحددة...',
        actualQty: 'الكمية الفعلية المستلمة',
        actualQtyPlaceholder: 'الكمية الفعلية',
        excessShortQty: 'كمية زائدة/ناقصة',
        short_qty: 'عجز',
      },
      messages: {
        updateSuccess: 'تم تحديث الموافقة بنجاح',
        updateFailed: 'فشل تحديث الموافقة',
        bulkSuccess: 'تم التحديث الجماعي بنجاح',
        bulkFailed: 'فشل التحديث الجماعي للموافقات',
        selectAtLeastOne: 'يرجى تحديد موافقة واحدة على الأقل',
        noAttachmentAvailable: 'لا يوجد مرفق متاح',
        approveSuccess: 'تمت الموافقة بنجاح',
        rejectSuccess: 'تم الرفض بنجاح',
      },
      preview: {
        documentSummary: 'ملخص المستند',
        sapAtFetch: 'بيانات SAP (عند الجلب)',
      },
    },
    DocumentJourney: {
      header: {
        title: 'رحلة المستند',
        transporterDesc: 'المستندات التي تم تحميلها بموجب رمز الناقل {{code}}. افتح صفاً لمشاهدة سجل المرفقات وحالتها.',
        standardDesc: 'يمكن أن يحتوي رقم مستند واحد على مرفقات متعددة بحالات مختلفة. افتح صفاً للاطلاع على حالة كل مرفق والإجراءات.',
        detailDesc: 'المستند {{docNo}} • {{count}} من المرفقات. يتم عرض الحالة لكل مرفق أدناه — يمكن أن يحتوي المستند الواحد على عدة حالات.',
      },
      actions: {
        refresh: 'تحديث',
        back: 'رجوع',
        approve: 'موافقة',
        reject: 'رفض',
      },
      table: {
        cardTitle: 'المستندات',
        cardTransporterDesc: 'مستندات الناقل الخاصة بك فقط',
        cardStandardDesc: 'مجمعة حسب رقم المستند',
        attachmentsTooltip: '{{count}} من المرفقات',
      },
      columns: {
        att: 'المرفقات',
        documentNo: 'رقم المستند',
        columnType: 'النوع',
        columnCustomer: 'العميل',
        custCode: 'رمز العميل',
        material: 'المادة',
        year: 'السنة',
        app: 'التطبيق',
        posting: 'تاريخ النشر',
        columnFrom: 'من',
        columnTo: 'إلى',
        qty: 'الكمية',
        actual: 'الكمية الفعلية',
        vehicle: 'رقم المركبة',
        lr: 'رقم LR',
        tpt: 'رمز الناقل',
        transporter: 'اسم الناقل',
        lastUpdate: 'آخر تحديث',
      },
      details: {
        cardSummaryTitle: 'الملخص',
        cardSummaryDesc: 'اللقطة الحالية',
        types: 'الأنواع',
        detailCustomer: 'العميل',
        detailFrom: 'من',
        detailTo: 'إلى',
        sapSnapshot: 'SAP (آخر لقطة للمرفق)',
        cardHistoryTitle: 'السجل',
        cardHistoryDesc: 'جميع تغييرات الحالة والمرفقات',
      },
      status: {
        Approved: 'موافقة',
        Rejected: 'مرفوض',
        Pending: 'قيد الانتظار',
      },
      modal: {
        approveTitle: 'الموافقة على المرفق',
        rejectTitle: 'رفض المرفق',
      },
      form: {
        docNo: 'رقم المستند:',
        formType: 'النوع:',
        formCustomer: 'العميل:',
        quantity: 'الكمية:',
        remarksLabel: 'ملاحظات',
        remarksRequired: 'يرجى تقديم ملاحظات',
        remarksPlaceholder: 'أدخل ملاحظات الموافقة أو الرفض...',
        btnCancel: 'إلغاء',
        btnSubmit: 'إرسال',
      },
      messages: {
        updateSuccess: 'تم تحديث الموافقة بنجاح',
        updateFailed: 'فشل تحديث الموافقة',
      },
    },
    ReportsPOD: {
      header: {
        title: 'تقارير إثبات التسليم (POD)',
        description: 'التقرير المصفى والتحليلات لمستندات إثبات التسليم (POD) (بنفس تخطيط لوحة القيادة).',
      },
      actions: {
        excelReport: 'تصدير التقرير',
        view: 'عرض',
      },
      kpi: {
        kpiTotal: 'الإجمالي',
        kpiMatchingFilters: 'مطابقة التصفية',
        kpiTotalDesc: 'عرض كافة الحالات — اضغط لإعادة تعيين مصفاة الحالة',
        kpiPending: 'قيد الانتظار',
        kpiInReview: 'قيد المراجعة',
        kpiApproved: 'موافقة',
        kpiCompleted: 'مكتمل',
        kpiRejected: 'مرفوض',
        kpiNeedsAction: 'بحاجة لاتخاذ إجراء',
      },
      filters: {
        filterTitle: 'الفلاتر',
        filterDesc: 'تحسين الجدول وإحصاءات الملخص',
        filterDocType: 'نوع المستند',
        filterAllTypes: 'كافة الأنواع',
        filterStatus: 'الحالة',
        filterAllStatuses: 'كافة الحالات',
        filterDateRange: 'نطاق التاريخ',
        filterApply: 'تطبيق الفلاتر',
      },
      breakdown: {
        breakdownTitle: 'أنواع المستندات',
        breakdownDesc: 'تفصيل الفلاتر الحالية',
        breakdownNoData: 'لا يوجد تفصيل للأنواع بعد.',
      },
      table: {
        tableTitle: 'المستندات',
        tableDesc: 'النتائج المصفاة — انقر على أي صف لسجل المستند',
      },
      modals: {
        detailsTitle: 'تفاصيل إثبات التسليم (POD)',
        viewTitle: 'عرض المستند',
      },
      columns: {
        id: 'المعرف',
        documentNo: 'رقم المستند',
        docType: 'نوع المستند',
        quantity: 'الكمية',
        postingDate: 'تاريخ النشر',
        fromLocation: 'من الموقع',
        toLocation: 'إلى الموقع',
        transporterCode: 'رمز الناقل',
        transporterName: 'اسم الناقل',
        status: 'الحالة',
        action: 'إجراء',
        actions: 'الإجراءات',
        year: 'السنة',
        app: 'التطبيق',
        material: 'المادة',
        customerCode: 'رمز العميل',
        customerName: 'العميل',
      },
      details: {
        status: 'الحالة',
        documentNo: 'رقم المستند',
        postingDate: 'تاريخ النشر',
        type: 'النوع',
        materialCodeNo: 'رقم رمز المادة',
        fromLocation: 'من الموقع',
        toLocation: 'إلى الموقع',
        quantity: 'الكمية',
        vehicleNo: 'رقم المركبة',
        user: 'المستخدم',
        attachment: 'المرفق',
        viewAttachment: 'عرض المرفق',
        downloadPdf: 'تنزيل ملف PDF',
        openInNewTab: 'فتح في علامة تبويب جديدة',
        loadingAttachment: 'جاري تحميل المرفق...',
        failedToLoad: 'فشل في تحميل المرفق.',
        noAttachment: 'لا يوجد مرفق للمعاينة.',
      },
      types: {
        allot: 'تخصيص',
        grn: 'إشعار استلام البضائع',
        returnRequest: 'طلب إرجاع',
        relocation: 'تغيير الموقع',
        typeAllotment: 'تخصيص (ALT)',
        typeDhr: 'إلغاء التأجير (DHR)',
        typeGrn: 'إشعار استلام البضائع (GRN)',
        typeRelOut: 'تغيير الموقع (RELO)',
        typeTradingSale: 'بيع تجاري (TS)',
        typeJobWork: 'job_work',
        typeTradingCell: 'trading_cell',
      },
      status: {
        Approved: 'موافقة',
        Rejected: 'مرفوض',
        Pending: 'قيد الانتظار',
      },
    },
    Common: {
      general: {
        loading: 'جاري التحميل...',
        save: 'حفظ',
        cancel: 'إلغاء',
        reset: 'إعادة تعيين',
        paginationTotal: 'عرض {{rangeStart}}–{{rangeEnd}} من {{total}} سجلات',
        submit: 'إرسال',
        close: 'إغلاق',
        back: 'رجوع',
        next: 'التالي',
        welcomeUser: 'مرحباً بك مجدداً',
        kpiRollingDesc: 'تستخدم المؤشرات أدناه نافذة متحركة تختارها؛ تظل تقارير إثبات التسليم (POD) طوال الوقت ما لم تقم بتصفية التواريخ هناك.',
        rollingWindow: 'النافذة المتحركة',
        refreshingWindow: 'جاري تحديث النافذة',
        last7days: 'آخر 7 أيام',
        last15days: 'آخر 15 يوماً',
        last30days: 'آخر 30 يوماً',
        last60days: 'آخر 60 يوماً',
        last90days: 'آخر 90 يوماً',
        total: 'إجمالي',
        inWindow: 'في النافذة',
        inReview: 'قيد المراجعة',
        ofTotal: 'من الإجمالي',
        completed: 'مكتمل',
        needsAction: 'يتطلب إجراء',
        recentApprovals: 'الموافقات الأخيرة',
        quickLinks: 'روابط سريعة',
        jumpToCommon: 'الانتقال إلى سير العمل المشترك',
        transporterWorkflows: 'سير عمل الناقل',
        documentTypes: 'أنواع المستندات',
        breakdownWindow: 'التحليل التفصيلي للنافذة الزمنية المحددة',
        open: 'فتح',
      },
      errors: {
        required: 'هذا الحقل مطلوب',
        invalidEmail: 'الرجاء إدخال بريد إلكتروني صالح',
        somethingWrong: 'حدث خطأ ما',
      },
    },
  },
};

// Post-processor: gracefully converts missing keys to beautiful readable English words
const keyConverterPostProcessor = {
  type: 'postProcessor' as const,
  name: 'keyConverter',
  process: (value: string, key: string | string[], _options: any) => {
    const keyStr = Array.isArray(key) ? key[0] : key;
    if (value === keyStr || !value) {
      const parts = keyStr.split('.');
      const lastPart = parts[parts.length - 1];
      return lastPart
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
    }
    return value;
  },
};

const getTranslationUrlTemplate = () => {
  const envVal = import.meta.env.VITE_TRANSLATION_API_URL || '';
  const cleanedEnvVal = envVal.replace(/\/+$/, '');
  if (cleanedEnvVal.includes('/api/v1/translations')) {
    return cleanedEnvVal;
  }
  return `${cleanedEnvVal}/api/v1/translations/pod-web/{{lng}}?ns={{ns}}`;
};

const deepMerge = (target: any, source: any): any => {
  const output = { ...target };
  if (target && typeof target === 'object' && source && typeof source === 'object') {
    Object.keys(source).forEach((key) => {
      if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
        if (!(key in target)) {
          output[key] = source[key];
        } else {
          output[key] = deepMerge(target[key], source[key]);
        }
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
};

const TRANSLATION_API_URL = getTranslationUrlTemplate();
const TRANSLATION_API_KEY = import.meta.env.VITE_TRANSLATION_API_KEY || 'key_leapindia_abc123';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .use(keyConverterPostProcessor)
  .init({
    lng: localStorage.getItem('i18nextLng') || 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar'],
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    backend: {
      loadPath: TRANSLATION_API_URL,
      customHeaders: {
        'X-API-Key': TRANSLATION_API_KEY,
      },
      request: (_options: any, url: string, _payload: any, callback: any) => {
        // Extract language and namespace from URL to find local fallback
        let lng: 'en' | 'ar' = url.includes('/ar') ? 'ar' : 'en';
        let ns = 'Common';
        try {
          const urlObj = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
          const nsParam = urlObj.searchParams.get('ns');
          if (nsParam) ns = nsParam;
        } catch (e) {
          const nsMatch = url.match(/[?&]ns=([^&]+)/);
          if (nsMatch) ns = nsMatch ? nsMatch[1] : 'Common';
        }

        const localNsData = (fallbackResources[lng] && (fallbackResources[lng] as any)[ns]) || {};

        const remoteTranslationBase = (import.meta.env.VITE_TRANSLATION_API_URL || '').trim();
        if (!remoteTranslationBase) {
          callback(null, { status: 200, data: localNsData });
          return;
        }

        // Attempt to fetch from remote translation backend API if configured
        fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-API-Key': TRANSLATION_API_KEY,
          },
        })
          .then((res) => {
            if (!res.ok) {
              throw new Error(`API returned HTTP ${res.status}`);
            }
            return res.json();
          })
          .then((data) => {
            // Merge database translations (which take precedence) with local fallbacks
            const dbData = data && typeof data === 'object' ? data : {};
            const merged = deepMerge(localNsData, dbData);
            callback(null, { status: 200, data: merged });
          })
          .catch((_err) => {
            // Silent fallback to local hardcoded namespace dictionary
            callback(null, { status: 200, data: localNsData });
          });
      },
    },
    // We fetch and parse all namespaces locally and dynamically
    ns: ['Login', 'Sidebar', 'UploadPOD', 'PendingPOD', 'ReportsPOD', 'Common', 'BulkPodUpload', 'DocumentJourney', 'Header'],
    defaultNS: 'Common',
    react: {
      useSuspense: false,
    },
    keySeparator: '.',
    nsSeparator: ':',
    postProcess: ['keyConverter'],
  });

// Setup dynamic attribute configurations on initialization & changes
const updateDocumentDirection = (lng: string) => {
  const isRtl = lng?.startsWith('ar');
  document.documentElement.dir = isRtl ? 'rtl' : 'ltr'; // Dynamically switch layout direction for dynamic RTL/LTR support
  document.documentElement.lang = lng;

  // Set gorgeous font adjustments and base transitions
  if (isRtl) {
    document.body.style.fontFamily = "'Cairo', 'Inter', system-ui, -apple-system, sans-serif";
    document.body.classList.add('rtl-mode');
  } else {
    document.body.style.fontFamily = "'Inter', system-ui, -apple-system, sans-serif";
    document.body.classList.remove('rtl-mode');
  }
};

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
  updateDocumentDirection(lng);
});

// Run initial settings for directionality
updateDocumentDirection(i18n.language || 'en');

export default i18n;
